import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Campaign } from 'app/models/campaign2.model';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';
import { moment } from 'fullcalendar';
import { MessageService, SelectItem } from 'primeng/api';

@Component({
  selector: 'app-campaign-detail2',
  templateUrl: './campaign-detail2.component.html',
  styleUrls: ['./campaign-detail2.component.css', '../coupon-setup.scss']
})
export class CampaignDetail2Component implements OnInit {

  campaignId: number;
  form: FormGroup;
  campaignFields: any;
  invalidSubmit: boolean;
  budgetType: SelectItem[] = [{label: '', value: null}];

  updateCampaignData: any;

  defaultStartDate: Date;
  defaultEndDate: Date;
  startingEndDate: Date;
  today = new Date();

  constructor(
    private fb: FormBuilder,
    private campaign2Service: Campaign2Service,
    private activatedRoute: ActivatedRoute,
    private messageService: MessageService,
    private translate: TranslateService,
    private router: Router
  ) { }

  ngOnInit() {
    // Recupero DTO FORM
    this.campaign2Service.getCampaignFields().subscribe(res => this.campaignFields = res);
    this.campaign2Service.getBudgetType().subscribe(response => {
      response.forEach(el => {
        this.budgetType.push({label: el.name, value: el.id});
      });
    })

    this.campaignId = this.activatedRoute.snapshot.params['id'];

    // se siamo in edit carico i dati nel form
    if(this.campaignId){
      this.campaign2Service.getCampaign(this.campaignId).subscribe(
        res => {
          // setto le date che mi ritornano nel form
          this.defaultStartDate = new Date(res[0].start_date);
          this.defaultEndDate = new Date(res[0].end_date);

          this.form = this.fb.group({
            name: res[0].name,
            start_date: new Date(res[0].start_date),
            end_date: new Date(res[0].end_date),
            start_fuition_date: new Date(res[0].start_fruition_date),
            end_fruition_date: new Date(res[0].end_frution_date),
            campaign_type_id: res[0].campaign_type_id,
            description: res[0].description,
            budget: res[0].budget,
            budget_type_id: res[0].budget_type_id,
            priority: res[0].priority
          });
          this.updateCampaignData = res[0];
        }
      )
    }else{
      this.form = this.fb.group({
        code: [''],
        name: [''],
        start_date: [''],
        end_date: [''],
        description: [''],
        budget: [''],
        budget_type_id: [''],
      })
    }
  }

  save(){
    if (!this.form.valid ) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    // se presente l'id in querypath allora faccio l'update, altrimenti creo una nuova campagna
    if(this.campaignId){
      const createCampaign = {
        name: this.form.get('name').value,
        description: this.form.get('description').value,
        start_date: moment(this.form.get('start_date').value).format('YYYY-MM-DD'),
        end_date:  moment(this.form.get('end_date').value).format('YYYY-MM-DD'),
        budget_type_id: this.form.get('budget_type_id').value,
        budget: this.form.get('budget').value,
        campaign_type_id: this.updateCampaignData.campaign_type_id,
        priority: this.updateCampaignData.priority,
        flg_pressure_rules: this.updateCampaignData.flg_pressure_rules
      }
      this.campaign2Service.updateCampaign(createCampaign, this.campaignId).subscribe(() => {
        this.messageService.add({severity: 'success', summary: 'Success', detail: this.translate.instant('campaign.updateCampaignSuccess')});
        this.goBack();
      });
    } else {
      this.campaign2Service.getParamCampaignTypeId().subscribe( res => {
        const createCampaign = {
          name: this.form.get('name').value,
          description: this.form.get('description').value,
          start_date: moment(this.form.get('start_date').value).format('YYYY-MM-DD'),
          end_date:  moment(this.form.get('end_date').value).format('YYYY-MM-DD'),
          budget_type_id: this.form.get('budget_type_id').value,
          budget: this.form.get('budget').value,
          campaign_type_id: res.param_code,
          priority: 0,
          flg_pressure_rules: '0'
        }
        this.campaign2Service.createCampaign(createCampaign).subscribe(()=>{
          this.messageService.add({severity: 'success', summary: 'Success', detail: this.translate.instant('campaign.createCampaignSuccess')});
          this.goBack();
        })
      });
    }
  }

  goBack(){
    this.router.navigate(['campaign-list-2']);
  }

  setStartDate() {
    if (!!this.form.get('start_date').value) {
      this.startingEndDate = this.form.get('start_date').value;
      return this.form.get('start_date').value;
    }
  }


  setEndDate(endDateField: any) {
    if (!!this.form.get('end_date').value) {
      return this.form.get('end_date').value;
    }
    else {
      if (endDateField && this.startingEndDate) {
        this.form.get('end_date').setValue(this.startingEndDate);
        endDateField.calendar.currentYear = this.startingEndDate.getFullYear();
        endDateField.calendar.currentMonth = this.startingEndDate.getMonth();
      }
      console.log(this.startingEndDate)
      return this.startingEndDate
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-detail2/campaign-detail2.component.ts